import Button from "../Button";
import InfoSvg from "../../Svg/InfoSvg";
import Modal from "react-bootstrap/Modal";
import React, { useContext, useEffect, useState } from "react";
import AlertContext from "../../context/AlertContext";
import ErrorNoticeSvgIcon from "../../Svg/ErrorNoticeSvgIcon";
import CompleteSvgIcon from "../CommonComponents/CompleteSvgIcon";
import WarningNoticeSvgIcon from "../../Svg/WarningNoticeSvgIcon";
import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";
import Progressbar from "../CommonComponents/Progressbar";

export default function Notify() {
  const { buttonDisable, showNotify, qnTrack, VideoSaved, setButtonDisable } =
    useContext(AlertContext);

  const { handleClose, handleUnAuthAlert } = useCommonFunctionHooks();
  const [checkboxValue, setCheckboxValue] = useState(true);

  useEffect(() => {
    if (showNotify.hasOwnProperty("checkbox")) {
      setCheckboxValue(true);
    }
  }, [showNotify]);

  useEffect(() => {
    if (qnTrack.current === VideoSaved) setButtonDisable(false);
  }, [qnTrack, setButtonDisable, VideoSaved]);

  if (!showNotify.show) {
    return null;
  }

  return (
    <Modal
      centered
      onHide={handleClose}
      show={showNotify.show}
      size={showNotify.size}
      style={{ zIndex: 9999 }}
      fullscreen={showNotify.fullscreen}
      aria-labelledby="contained-modal-title-vcenter"
      autoFocus={!showNotify.autoFocus ? showNotify.autoFocus : true}
      backdrop={showNotify.backdrop ? showNotify.backdrop : "static"}
      keyboard={false}
      className={
        showNotify.position === "top"
          ? "modalMainContainerForProctor"
          : showNotify.position === "bottom"
          ? "modalMainContainerForProctorBottom"
          : showNotify.fullscreen
          ? "modalMainContainerFullScreen"
          : "modalMainContainer"
      }
    >
      <Modal.Header
        closeButton={showNotify.showClose}
        className={
          showNotify.hasOwnProperty("title")
            ? "modalHeader"
            : showNotify.component === "leaderBoard"
            ? "modalHeaderForLeaderBoard"
            : "modalHeaderWithTitleSvgOnly"
        }
      >
        <Modal.Title className={"modalTitle"} style={(showNotify.sql || showNotify.job) && {display: "flex", gap: "20px", alignItems: "center"}}>
          <div
            className={
              showNotify.title && showNotify.titleSvg && "modalHeaderTitleSvg"
            }
            style={showNotify.sql && {height: "56px"}}
          >
            {showNotify.titleSvg === "success" ? (
              <CompleteSvgIcon />
            ) : showNotify.titleSvg === "warning" ? (
              <WarningNoticeSvgIcon />
            ) : showNotify.titleSvg === "error" ? (
              <ErrorNoticeSvgIcon />
            ) : (
              showNotify.titleSvg === "info" && <InfoSvg component="notify" />
            )}
          </div>
          {showNotify.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modalBody">{showNotify.msg}</Modal.Body>
      {showNotify.hasOwnProperty("checkbox") && (
        <Modal.Body className="modalBody">
          <div className="checkboxContainer form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="notifyCheckbox"
              checked={checkboxValue}
              onChange={(e) => {
                setCheckboxValue(e.target.checked);
                if (typeof showNotify.checkboxFunction === "function") {
                  showNotify.checkboxFunction(e);
                }
              }}
            />
            <label className="form-check-label" htmlFor="notifyCheckbox">
              {showNotify.checkbox}
            </label>
          </div>
        </Modal.Body>
      )}

      {showNotify.hasOwnProperty("sql") && (
        <Modal.Body className="modalBody sqlProgress">
          <Progressbar from={"sql"} percentage={showNotify.percentage ?? 0} />
          <div className="notifySqlData">
            <p className="sqlData">0</p>
            <div className="sqlDataCompleted">
              <div className="sqlData">{showNotify.completed}</div>
              <div className="sqlTitle">completed</div>
            </div>
            <div className="sqlDataTotal">
              <div className="sqlData">{showNotify.total}</div>
              <div className="sqlTitle">Total</div>
            </div>
          </div>
        </Modal.Body>
      )}

      {!showNotify.hideButton && (
        <Modal.Footer className={`modalFooter ${showNotify.buttonStyle}`}>
          {showNotify.hasOwnProperty("secondaryButton") && (
            <Button
              size={"sm"}
              onClick={
                showNotify.hasOwnProperty("secondaryButtonFunction")
                  ? showNotify.secondaryButtonFunction
                  : handleClose
              }
              hierarchy={{
                type: "secondaryGrey",
                buttonText: showNotify.secondaryButton,
              }}
            />
          )}
          <Button
            size={"sm"}
            disable={buttonDisable}
            hierarchy={{
              type: "primary",
              buttonText: showNotify.hasOwnProperty("primaryButton")
                ? showNotify.primaryButton
                : "Ok",
            }}
            onClick={
              showNotify.hasOwnProperty("primaryButtonFunction")
                ? showNotify.primaryButtonFunction
                : showNotify.isUnAuth
                ? handleUnAuthAlert
                : handleClose
            }
          />
        </Modal.Footer>
      )}
    </Modal>
  );
}
